module.exports = __webpack_public_path__ + "img/symbol_17_normal.98653e0a.png";